import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
  open: boolean;
  isSaving: boolean;
  onCancel: VoidFunction;
  onConfirm: VoidFunction;
};

export default function CloneLeaveDialog({ open, isSaving, onCancel, onConfirm }: Props) {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="clone-leave-title">
      <DialogTitle id="clone-leave-title">Descartar cópia do evento?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isSaving
            ? 'Aguarde a conclusão do salvamento antes de sair.'
            : 'Esta cópia ainda não foi salva. Ao sair, o rascunho e todas as alterações serão descartados. O evento original será preservado.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} autoFocus>Continuar editando</Button>
        <Button color="error" variant="contained" disabled={isSaving} onClick={onConfirm}>
          Descartar e sair
        </Button>
      </DialogActions>
    </Dialog>
  );
}
